<!--[if lt IE 9]> <script src="//html5shim.googlecode.com/svn/trunk/html5.js"></script> <![endif]-->
<div *ngIf="!connected" class="not-connected-banner">
    You are not connected to the server
    <button mat-raised-button (click)="checkArmaServConnection()">Reconect now !</button>
</div>
<div *ngIf="mErrorInitApp" class="not-connected-banner">
    Unable to initialize the application, please reload this page ! <br>
    {{mErrorInitApp}}
    <button mat-raised-button (click)="reloadPage()">Reload</button>
</div>


<div class="main-box" *ngIf="isInit; else elseTemplate">
    <header class="row header" id="main-header">
        <app-app-tool-bar></app-app-tool-bar>
    </header>
    <div class="row content" id="main-content">
        <router-outlet (activate)='onActivate($event)'></router-outlet>
    </div>
    <footer class="row footer" id="main-footer">
        <div class="powered-by" (click)="poweredByClick()">
            Powered by
            <img src="assets/ariadis-text.png" alt="Ariadis" height="18px">
        </div>
    </footer>
</div>
<ng-template #elseTemplate>
    <div class="center-content">
        <div *ngIf="!mErrorInitApp">{{'Chargement' | translate}}....</div>
        <img src="assets/ariadis-logo-alpha.png" height="250px" alt="AriadisLogo">
        <div *ngIf="HTML_LoadingInfo">
            {{HTML_LoadingInfo}}
            <mat-progress-bar mode="buffer"></mat-progress-bar>
        </div>
    </div>
</ng-template>
